import { NormalRouting } from "./NormalRouting";
import { PrivateRouting } from "./PrivateRouting";
import { PublicRouting } from "./PublicRouting";


export const queryBreadCrumbLayout = (pathname) =>{
	let layoutType = {};
	const routes = [...NormalRouting, ...PrivateRouting, ...PublicRouting]
	layoutType =  routes?.find((route)=>
	route.path.includes(":")?
	route.path.slice(0,route.path.indexOf(":")) === pathname.slice(0, route.path.indexOf(":"))
	:
	route.path===pathname);
	return layoutType ? layoutType : 'public';
}